<template>
	<div class="messenger-contacts-online">

		<!-- MESSENGER CONTACT BTN -->
		<button
			class="messenger-contact-btn"
			v-for="item in filteredData"
		>
			<!-- STATUS ICON -->
			<span class="status-icon" :class="group">
				<span
					v-if="group == 'online'"
					class="status-icon-overlay"
					:class="'is-'+item.ICU.status"
				>
				</span>
			</span>

			<span class="text">{{ item.ICU.screenName }}</span>
		</button>
	</div>
</template>

<script>
	export default {
	    components: {

	    },
	    props: {
	    	data: {
	    		type: Array,
	    		required: true
	    	},
	    	group: {
	    		type: String,
	    		required: true
	    	}
	    },
	    computed: {
	    	filteredData() {
	    		let contacts = [];
	    		this.group == 'online'
	    			? contacts = this.data.filter(item => item.ICU.status !== 'offline' && item.ICU.status !== 'invisible')
	    			: contacts = this.data.filter(item => item.ICU.status == 'offline');
	    		// return alphabetical
	    		return contacts.sort((a, b) => a.screenName - b.screenName );
	    	}
	    }
	}
</script>

<style lang="scss" scoped>


	.status-icon,
	.status-icon-overlay {
		position: relative;
		display: block;
		// box-shadow: 0 0 1px 0 black;
		width: 21px;
		height: 21px;
		margin-right: rem-calc(5);
		background: url('./assets/img/spritesheet-icons@2x.png') no-repeat;
		background-size: 198px 22px;
		transform: scale(0.85);
		// opacity: 0;
	}

	.status-icon-overlay {
		position: absolute;
		top: 0;
		left: -1px;
		transform: none;
	}

	.online { background-position: -0px -0px; }
	.offline { background-position: -22px -0px; }
	.is-request { background-position: -44px -0px; }
	.is-na { background-position: -66px -0px; }
	.is-msg { background-position: -88px -0px; }
	.is-invisible { background-position: -110px -0px; }
	.is-free-for-chat { background-position: -132px -0px; }
	.is-do-not-disturb { background-position: -154px -0px; }
	.is-away { background-position: -176px -0px; }

	.messenger-contact-btn {
		display: flex;
		width: 100%; //rem-calc(215);
		border: 0;
		padding: rem-calc(2 5);
		font-size: rem-calc(15);
		font-weight: 500; // TODO: test this again on non-retina
		text-align: left;
		cursor: default;
		background-color: transparent;

		.text {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		&:active {
			background-color: #415856;
			color: white;
		}
	}

	.is-offline .messenger-contact-btn {
		color: #cc5d66;
	}
</style>